import React, { ReactElement } from 'react';
import { Input } from 'reactstrap';
import { FormNodeMarkdownModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor, UpdateFormProps } from './AbstractElementEditor';

export class FormMarkdownEditor extends AbstractElementEditor<FormNodeMarkdownModel> {
  public getDescription(): string {
    return 'Markdown-enabled text';
  }

  public getName(): string {
    return 'Text Block';
  }

  public getIcon(): string {
    return 'title';
  }

  public override getDefaultValues(): Partial<Omit<FormNodeMarkdownModel, 'id' | 'type'>> {
    return {
      markdown: '',
    };
  }

  public override getUpdateForm({
    node,
    update,
  }: UpdateFormProps<FormNodeMarkdownModel>): ReactElement {
    return (
      <Input
        onChange={(e) => {
          update({ ...node, markdown: e.target.value });
        }}
        rows={15}
        type="textarea"
        value={node.markdown}
      />
    );
  }
}
